import isServer from 'commons/isServer';
import getEnvValue from 'commons/getEnvValue';

const getAlexandriaUrl = () =>
  isServer() && process.env.PRIVATE_GRAPHQL_BASE_URL
    ? process.env.PRIVATE_GRAPHQL_BASE_URL
    : getEnvValue('NEXT_PUBLIC_GRAPHQL_BASE_URL');

export default getAlexandriaUrl;
